import { showToast } from '@/lib/toast'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

export type SocialPlatform = 'facebook' | 'twitter'

export const SOCIAL_URLS = {
  facebook: 'https://www.facebook.com/sharer/sharer.php',
  twitter: 'https://twitter.com/intent/tweet',
}

export function useShareLink(link?: string) {
  const [linkIsCopied, setLinkIsCopied] = useState(false)
  const t = useTranslations()

  function copyLink() {
    if (!link) return

    navigator.clipboard.writeText(link)
    setLinkIsCopied(true)
    showToast({
      message: t('profile-page.share-link-copied'),
      type: 'success',
    })
  }

  function createSharePlatformLink(platform: SocialPlatform, title = '') {
    let socialLink = link

    switch (platform) {
      case 'facebook': {
        socialLink = `${SOCIAL_URLS.facebook}?u=${link}`
        break
      }
      case 'twitter': {
        socialLink = `${SOCIAL_URLS.twitter}?text=${encodeURIComponent(
          title,
        )} %7C Explore the Worlds %7C VIVERSE ${encodeURIComponent(link!)}`
        break
      }
    }

    return socialLink
  }

  return {
    linkIsCopied,
    setLinkIsCopied,
    copyLink,
    createSharePlatformLink,
  }
}
